<form class="edit-form" *ngIf="!isLoading && clients" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.productTypes.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'repository.productTypes.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('client')" [list]="clients" label="repository.productTypes.edit.client.label"
    errorMsg="repository.productTypes.edit.client.errorMessage">
  </app-autocomplete>

  <section class="temperatures-field">
    <mat-form-field>
      <mat-label>{{ 'repository.productTypes.edit.minimum.label' | translate }}</mat-label>
      <input type="number" matInput formControlName="minimum">
      <mat-error>{{ 'repository.productTypes.edit.minimum.errorMessage' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'repository.productTypes.edit.maximum.label' | translate }}</mat-label>
      <input type="number" matInput formControlName="maximum">
      <mat-error>{{ 'repository.productTypes.edit.maximum.errorMessage' | translate }}</mat-error>
    </mat-form-field>
  </section>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>